<template>
  <el-tooltip class="item" effect="dark" content="输入数字时按ID查询，否则按名称查询, 需指定代理商查询" placement="top">
    <el-select
            v-model="data"
            value-key="name"
            v-bind="$attrs"
            filterable
            remote
            :remote-method="search"
            :loading="loading"
            @change="onChange"
            @clear="onClean"
            ref="factorAutoComplete"
            placeholder="请输入角色名称/ID"
            :disabled="disabled"
    >
      <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id">
      </el-option>
    </el-select>
  </el-tooltip>
</template>
<script>
    import { getRoleAutoComplete } from '@/service/user'
    // 目前不支持多选
    export default{
        props: {
            value: [Number, String],
            factorId: [Number, String],
            status: {
                type: [Number, String],
                default: null
            },
            limit: {
                type: Number,
                default: 10
            },
            initChooseFirst: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                data: null,
                loading: false,
                options: [],
                searchTimeOutHandle: null,
                disabled: true
            }
        },
        created() {
             
            if (!!this.factorId === true) {
                this.disabled = false
                this.search()
                //this.search(this.value, true)
            }
        },
        watch: {
            factorId(val) {
                this.onClean()
                this.search('')
            },
            value(val) {
                if (val !== this.data) {
                    this.$emit('input', this.value)
                    //this.search(val)
                    this.search()
                }
            }
        },
        methods: {
            search(query, isInit = false) {
                this.loading = true
                clearTimeout(this.searchTimeOutHandle)
                if (!!this.factorId === false) {
                    this.onClean()
                    return
                }
                let conditions = {
                    factor_id: this.factorId,
                    limit:100
                }
                if (this.status !== null) {
                    conditions.status = this.status
                }
                if (!!query) {
                    if (/^\d+$/.test(query) === true) {
                        conditions.id = query
                    } else {
                        conditions.name = query
                    }
                }
                let that = this
                let timeout = isInit ? 0 : 300
                this.searchTimeOutHandle = setTimeout(() => {
                    getRoleAutoComplete(conditions).then(response => {
                        that.loading = false
                        that.options = response
                        that.data = null
                        if (response.length > 0) {
                            if (!!that.value) {
                                that.options.forEach(item => {
                                    if (item.id === that.value) {
                                        that.data = that.value
                                    }
                                })
                            } else if (that.initChooseFirst) {
                                that.data = response[0].id
                            }
                        }
                        that.onChange()
                        if (isInit) {
                            that.$emit('created', that.data)
                        }
                    }).catch(err => {
                        console.log(err)
                        that.loading = false
                    })
                }, timeout)
            },
            onChange(item) {
                this.$emit('input', this.data)
            },
            onClean() {
                if (!!this.factorId === false) {
                    this.disabled = true
                    this.options = []
                } else {
                    this.disabled = false
                }
                // this.options = []
                this.data = null
                this.$emit('input', '')
            }
        }
    }
</script>
